'use strict';

import { Component } from 'react';
import { InstantSearch } from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import createHistory from 'history/createBrowserHistory';
import Media from 'react-media';
import { createURL, searchStateToUrl, urlToSearchState } from './state';
import ScrollTo from "./ScrollTo";
import Filters from "./Filters";
import { Results } from "./Results";

class App extends Component {
	
	searchClient = algoliasearch(this.props.algolia.app_id, this.props.algolia.key);
	history = null;
	historyTimeout = null;
	recentChangeTimeout = null;
	unlisten = null;
	
	state = {
		showFilters: false,
	};
	
	constructor(props) {
		super(props);
		
		this.history = createHistory();
		
		const search_state = urlToSearchState(this.history.location);
		
		this.state = {
			recentlyChanged: false,
			searchState: search_state,
			searchKey: createURL(search_state),
		};
	}
	
	componentDidMount() {
		const { history } = this;
		
		this.unlisten = history.listen(location => {
			if (! location.state || location.state.searchKey !== this.state.searchKey) {
				this.setState({
					searchState: urlToSearchState(location),
				});
			}
		});
	}
	
	componentWillUnmount() {
		this.unlisten();
	}
	
	onSearchStateChange = (search_state) => {
		clearTimeout(this.historyTimeout);
		clearTimeout(this.recentChangeTimeout);
		
		// Only show change when it's not related to the query string
		// TODO: This should probably be done with connectStateResults
		const recently_changed = search_state.query === this.state.searchState.query;
		
		const state = { searchState: search_state, searchKey: createURL(search_state), recentlyChanged: recently_changed };
		
		this.historyTimeout = setTimeout(() => {
			this.history.push(
				searchStateToUrl(this.history.location, search_state),
				state
			);
		}, 1000);
		
		this.recentChangeTimeout = setTimeout(() => this.setState({ recentlyChanged: false }), 300);
		
		this.setState(state);
	};
	
	render() {
		const { recentlyChanged } = this.state;
		const config = {
			searchClient: this.searchClient,
			indexName: this.props.algolia.index,
			searchState: this.state.searchState,
			onSearchStateChange: this.onSearchStateChange,
			createURL
		};
		
		return (
			<div className="tailwind">
				<Media query={ { maxWidth: 768 } }>{ is_small => (
					<InstantSearch { ...config }>
						<div className="md:flex">
							{ this.filters(is_small) }
							<div className="flex-1" style={ { opacity: recentlyChanged ? 0.2 : 1 } }>
								<ScrollTo>
									<Results />
								</ScrollTo>
							</div>
						</div>
					</InstantSearch>
				) }</Media>
			</div>
		);
	}
	
	filters(is_small) {
		const { showFilters } = this.state;
		
		let button = null;
		if (is_small && ! showFilters) {
			button = (
				<div className="mb-2">
					<button className="block w-full btn btn-blue" onClick={ () => this.setState({ showFilters: true }) }>
						Show Filters
					</button>
				</div>
			);
		} else if (is_small && showFilters) {
			button = (
				<div className="mb-2">
					<button className="block w-full btn btn-blue" onClick={ () => this.setState({ showFilters: false }) }>
						Hide Filters
					</button>
				</div>
			);
		}
		
		return (
			<div className={ is_small ? 'w-full' : 'md:w-1/3 xl:w-1/4 flex-shrink-0 pr-4' }>
				{ button }
				<Filters className={ is_small && ! showFilters ? 'hidden' : '' } />
			</div>
		);
	}
}

export default App;
